import { Card, CardContent, CardHeader } from "@/components/ui/card";

export function FlowerCardSkeleton() {
  return (
    <Card className="overflow-hidden">
      <CardHeader className="p-0">
        <div className="aspect-square relative overflow-hidden bg-muted animate-pulse">
          <div className="absolute inset-0 bg-gradient-to-br from-muted via-muted/80 to-muted">
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="text-6xl text-muted-foreground/30">🌸</div>
            </div>
          </div>
        </div>
      </CardHeader>
      
      <CardContent className="p-4 bg-card">
        <div className="space-y-3">
          <div>
            <div className="h-6 bg-muted rounded animate-pulse mb-2"></div>
            <div className="flex items-center gap-2">
              <div className="h-5 w-16 bg-muted rounded-full animate-pulse"></div>
              <div className="h-5 w-12 bg-muted rounded animate-pulse"></div>
            </div>
          </div>

          <div className="space-y-2">
            <div className="h-4 w-20 bg-muted rounded animate-pulse"></div>
            <div className="h-4 w-24 bg-muted rounded animate-pulse"></div>
          </div>

          <div className="h-8 bg-muted rounded animate-pulse mt-3"></div>
        </div>
      </CardContent>
    </Card>
  );
}